import Overview from '../Overview';
import Challenge from '../Challenge';
import Solution from '../Solution';
import Results from '../Results';
import Conclusion from '../Conclusion';

const SectionRegistry = {
  Overview,
  Challenge,
  Solution,
  Results,
  Conclusion
};

export default SectionRegistry;